import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import LanguageSelect from "components/ProjectNonSpecificComponents/Elements/LanguageSelect"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { UserContext } from "components/ProjectSpecificComponents/Contexts/UserContext"
import IconButton from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/IconButton"
import MobileNavBarMenu from "components/ProjectSpecificComponents/Elements/Navigation/molecules/MobileNavBarMenu"
import UserSideActiveConfigNavigation from "components/ProjectSpecificComponents/Elements/Tables/organisms/UserSideActiveConfigNavigation"
import { observer } from "mobx-react"
import React, { useContext, useState } from "react"
import { useLocation } from "react-router"
import styled from "styled-components"
import { UserInfo } from "../UserInfo"

interface Props {}

const NavBarMobile = observer(({}: Props) => {
	const formStore = useFormStore()
	const store = useStore()
	const { user } = useContext(UserContext)
	const [isMenuShown, setIsMenuShown] = useState(false)
	const location = useLocation()
	return (
		<>
			<Base
				style={{
					color: formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)",
					background: formStore.settingsData.personalize.colorHeader ?? "var(--white)",
					borderBottom: "2px solid var(--gray-c2)",
				}}
			>
				<HyperDiv className="fill-cter relative" direction="row" centered spacedEvenly>
					{location.pathname != ROUTES.USER && (
						<HyperDiv
							style={{
								position: "absolute",
								left: 18,
								height: "100%",
							}}
							centered
						>
							<IconButton
								iconKey="menu"
								onClick={() => setIsMenuShown(true)}
								iconColor={formStore.settingsData.personalize.colorHeaderText}
							/>
						</HyperDiv>
					)}
					{location.pathname == ROUTES.USER && <UserSideActiveConfigNavigation />}
					<HyperDiv direction="row" centered spaceBetweenElems="1rem">
						<LanguageSelect />
						{!store.instanceAnonymousUsers && <UserInfo />}
					</HyperDiv>
				</HyperDiv>
			</Base>

			<MobileNavBarMenu
				hidden={!isMenuShown}
				onTapBackground={() => setIsMenuShown(false)}
				onNavigation={() => setIsMenuShown(false)}
			/>
		</>
	)
})

export default NavBarMobile

const Base = styled.div`
	height: 62px;
	position: sticky;
	top: 0;
	z-index: 9;

	// Text
	font-size: 18px;
	font-weight: bold;
	letter-spacing: 0.067em;
`
